import { useMutation } from '@apollo/client'
import { ApproveClearanceStatus, ApproveClearanceStatusVariables } from '../../types'
import { APPROVE_CLEARANCE_STATUS } from './operations'

export const useApproveClearanceStatus = () =>
  useMutation<ApproveClearanceStatus, ApproveClearanceStatusVariables>(APPROVE_CLEARANCE_STATUS)
